import { render, staticRenderFns } from "./TedarikciOncelikButon.vue?vue&type=template&id=13022785"
import script from "./TedarikciOncelikButon.vue?vue&type=script&lang=js"
export * from "./TedarikciOncelikButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports